module.exports = __webpack_public_path__ + "img/board.42e6d7ea.svg";